import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import { buildMedicalClinicSchema } from './medicalClinicSchema';

interface Props {
  description?: string;
  title?: string;
  isArticle?: boolean;
  publishedAt?: string;
  author?: string;
  lang?: string;
  socialImage?: string;
  companyLogo?: string;
}

export const Schema: React.FC<Props> = ({
  description = '',
  lang = 'fi',
  title = '',
  author = '',
  socialImage = '',
  publishedAt = '',
  companyLogo = '',
  isArticle = false,
}) => {
  const {
    site: { siteMetadata },
    strapiYhteys: contact,
  } = useStaticQuery(
    graphql`
      query SchemaQuery {
        site {
          siteMetadata {
            title
            siteUrl
            socialImage
            company
            email
            description
          }
        }
        strapiYhteys {
          PhoneNumber
          StreetAddress
          PostalCode
          City
        }
      }
    `
  );

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    description: description || siteMetadata.description,
    headline: title,
    publisher: {
      '@type': 'Organization',
      name: siteMetadata.title,
      logo: { '@type': 'ImageObject', url: companyLogo },
    },
    author: author || {
      '@type': 'Organization',
      name: siteMetadata.title,
      logo: { '@type': 'ImageObject', url: companyLogo },
    },
    editor: author || undefined,
    datePublished: publishedAt,
    dateCreated: publishedAt,
    dateModified: publishedAt,
    inLanguage: lang,
    image: socialImage,
  };

  const schema = isArticle
    ? articleSchema
    : buildMedicalClinicSchema(contact, siteMetadata);

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default Schema;
